<div class="forgot-password-container">
    <form class="forgot-password-form" [formGroup]="formGroup"
        (submit)="submitForm()"
        (reset)="onCancel.emit()"
    >
        <h1 class="form-title">Восстановление пароля</h1>

        <label class="input-container">
            <input type="text" [placeholder]="'LOGIN' | i18n" formControlName="login"/>
        </label>

        <div class="buttons-container">
            <button type="submit" class="confirm-btn"
                [disabled]="formGroup.invalid"
            >Послать письмо</button>

            <button type="reset" class="cancel-btn"
            >{{"CANCEL" | i18n}}</button>
        </div>
    </form>
</div>
